import React, { Component } from "react";
import styled from "styled-components";
import { InputBox, Button } from "../../components/AuthComponents";
import { colors } from "../../resources/ThemeColors";
// redux
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { loginUser } from "../../store/modules/login/index";

//breakpoints
import { breakpoints } from "../../Media";

const MainDiv = styled.div`
  height: 100vh;
  background-color: ${colors.main};
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

const ContentCard = styled.div`
  height: 70%;
  width: 50%;
  border: 1px;
  position: absolute;
  background-color: white;
  border-radius: 18px;
  box-shadow: 0 3px 2px -2px black;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  @media (max-width: ${breakpoints.mobileMin}) {
    width: 90%;
    height: auto;
    margin: auto;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    width: 90%;
    margin: auto;
  }
`;

const LoginTitle = styled.h1`
  font-size: 2.2em;
  font-weight: 800;
  width: auto;
  color: #4c4f4e;

  @media (max-width: ${breakpoints.mobileMin}) {
    font-size: 1.8em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    font-size: 2.1em;
  }
`;

const InputDiv = styled.div`
  height: auto;
  width: 60%;
  margin-bottom: 1em;
  display: flex;
  flex-flow: column nowrap;

  @media (max-width: ${breakpoints.mobileMin}) {
    width: 75%;
    height: auto;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    height: auto;
  }
`;

// const ForgotPasswordText = styled.a`
//   font-size: 1em;
//   text-decoration: none;
//   color: black;
//   left: 0;

//   :hover {
//     color: ${colors.main};
//   }

//   @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
//   }
// `;

const RegisterText = styled.p`
  font-size: 1em;
  font-weight: 400;
  margin: auto;

  @media (max-width: ${breakpoints.mobileMin}) {
    font-size: 1em;
    margin-top: 1em;
    margin-bottom: 1em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    font-size: 1em;
    margin-top: 1em;
  }
`;

const RegisterLink = styled.a`
  text-decoration: none;
  color: black;
  font-size: 1em;
  font-weight: 600;

  :hover {
    text-decoration: none;
    color: ${colors.main};
  }

  @media (max-width: ${breakpoints.mobileMin}) {
    text-decoration: none;
    color: black;
    font-size: 1em;
    font-weight: 600;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
  }
`;

class Login extends Component {
  state = {
    email: "",
    password: "",
    error: null,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { loginUser } = this.props;
    const user = {
      email: this.state.email,
      password: this.state.password,
    };
    loginUser(user);
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  render() {
    const { isLoggedIn } = this.props;
    return isLoggedIn ? (
      <Redirect to="/landing" />
    ) : (
      <MainDiv>
        <ContentCard>
          <LoginTitle>Welcome Back.</LoginTitle>
          <InputDiv>
            <InputBox
              placeholder="email"
              type="email"
              name="email"
              onChange={this.handleChange}
            ></InputBox>
            <InputBox
              placeholder="password"
              type="password"
              top
              name="password"
              onChange={this.handleChange}
            ></InputBox>
            {/* <ForgotPasswordText href="">Forgot password?</ForgotPasswordText> */}
            <Button onClick={this.handleSubmit}>Login</Button>
            <RegisterText>
              Don't have an account?{" "}
              <RegisterLink href="/signup">Register here</RegisterLink>
            </RegisterText>
          </InputDiv>
        </ContentCard>
      </MainDiv>
    );
  }
}

export const mapStateToProps = (state) => ({
  isLoggedIn: state.loginReducer.isLoggedIn,
  isLoading: state.loginReducer.isLoading,
});

export const mapDispatchToProps = (dispatch) => ({
  loginUser: (user) => dispatch(loginUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
